/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { EditableComponent, ResponsiveGrid } from '@adobe/aem-react-editable-components';
import React, { FC, Suspense, useEffect, useState, useMemo } from 'react';
import clsx from 'clsx';
import { useStore } from '../../modules/store/cobrandStore';
import { CobrandWrapperSkeletonLoader } from './CobrandWrapperSkeletonLoader';

import {
  respGridUtil,
  updateAEMCQKeys,
  VariableColumnContainer as VariableColumnContainerMolecule,
} from '@marriott/mi-ui-library';
import { AEMReactCompMap, useAlloyTargetMethod } from '../../modules/utils';
import { WrapperProps, CobrandWrapperProps } from './CobrandWrapper.types';
import { StyledCobrandWrapper } from './CobrandWrapper.styles';
/* eslint-disable @nx/enforce-module-boundaries */
import { getMboxParamters, fetchDCADynamicModelForAlloy, useSession } from '@marriott/mi-headless-utils';
import { CobrandComparisonTray } from '../CobrandComparisonTray/CobrandComparisonTray';
export const CobrandWrapperConfig = {
  emptyLabel: 'CobrandWrapper',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/cobrandwrapper`,
};

/**
 *
 * @param props refers to the Container props
 * @description This Wrapper component will be helpful to do alloyJs call
 * and in response, if we have merchandising components involved in medelJson,
 * then single dca call will happen and update the components with updated mbox data
 */
export const DCADecision = (props: Record<string, unknown>) => {
  const { targetMbox } = props;
  const { isTargetContentLoaded, targetData } = useAlloyTargetMethod(targetMbox as string);
  const { datalayer, mvpOffers } = useSession();

  const [model, setModel] = useState({ ...props, isTargetContentLoaded });
  const [isUpdated, setIsUpdated] = useState(false);
  useEffect(() => {
    if (isTargetContentLoaded && targetData?.cobrandwrapper && !isUpdated && datalayer) {
      const respGridUtilMap = respGridUtil(targetData?.cobrandwrapper);
      const { mboxParameters } = getMboxParamters(respGridUtilMap);
      fetchDCADynamicModelForAlloy(mboxParameters, respGridUtilMap, datalayer, mvpOffers)?.then(res => {
        setModel({ ...model, ...res, isTargetContentLoaded: true });
        setIsUpdated(true);
      });
    } else if (isTargetContentLoaded && !targetData?.cobrandwrapper && !isUpdated) {
      setModel({ ...model, isTargetContentLoaded: true });
      setIsUpdated(true);
    }
  }, [isTargetContentLoaded, datalayer, mvpOffers]);

  return useMemo(() => <CobrandWrapperComponent {...(model as unknown as WrapperProps)} />, [model]);
};

export const CobrandWrapperComponent: FC<WrapperProps> = (props: WrapperProps) => {
  const { targetMbox } = props;
  const {
    header,
    headerTag,
    subHeader,
    ctaLabel,
    ctaLink,
    eyebrow,
    ctaType,
    trackingProperties,
    styleclass,
    componentID,
    pagePath,
    itemPath,
    isAuthorMode,
    desktopColumns,
    tabletColumns,
    mobileColumns,
    reverseStacking,
    contentAlignment,
    headerFontSize,
    subFontSize,
    subHeaderTag,
    descriptionText,
    descFontSize,
    isCardComparisonFeatureEnabled,
    isComparisonTrayEnabled,
    resolvedUrl = 'credit-cards',
    targetExperience,
    isTargetContentLoaded,
    enableFiveCardLayout,
  } = props as any;

  const updatedProps = updateAEMCQKeys(props);
  const cqItems = updatedProps['cqItems'];
  const { cobrandData } = useStore(store => store);
  const col = getColumnsObj(desktopColumns, tabletColumns, mobileColumns);
  const isFiveCardLayout = enableFiveCardLayout === 'true';
  const formWrapperArray = () => {
    const columnsArray = [];
    for (let i = 0; i < col.length; i++) {
      columnsArray.push([
        `variable-column-${i}`,
        `col-xl-${col?.[i].deskVal} col-md-${col?.[i].tabVal} col-${col?.[i].mobVal}  ${
          isFiveCardLayout && props?.isParentOfCobrandWrapper === 'false' ? 'container-wrapper' : 'column-containers'
        }`,
      ]);
    }
    return columnsArray;
  };

  const wrapperArray = formWrapperArray();

  const mapper = AEMReactCompMap(props?.allowedComponents);

  const authorComponentWrapper = (index: number) => {
    return (
      <ResponsiveGrid
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        pagePath={pagePath}
        itemPath={`${itemPath}/${wrapperArray[index][0]}`}
        columnCount="12"
        gridClassNames={''}
        customClassName={''}
        config={{
          isEmpty: () => true,
          resourceType: 'mi-aem-common-spa/components/container',
        }}
      />
    );
  };

  const publishComponentWrapper = useMemo(() => {
    return (columnName: string, jsonData: any, columnClass: string) => {
      const objToMap = props?.cqItems || jsonData;
      if (objToMap && objToMap[columnName]) {
        const column = objToMap[columnName];
        const columnItems = column[':items'];
        const columnOrder: string[] = column[':itemsOrder'];
        const componentsArray: JSX.Element[] = [];
        const isPersonalWrapper = Object.keys(columnItems).some(str => str.includes('cardcarousel'));
        columnOrder.forEach(itemKey => {
          if (Object.prototype.hasOwnProperty.call(columnItems, itemKey)) {
            const item = columnItems[itemKey];
            const itemType = item?.[':type']?.split('/').pop();
            if (Object.prototype.hasOwnProperty.call(mapper, itemType)) {
              const itemProps = {
                ...item,
                allowedComponents: props?.allowedComponents,
                resolvedUrl: resolvedUrl,
                isCardComparisonFeatureEnabled: String(isCardComparisonFeatureEnabled) === 'true',
                isComparisonTrayEnabled: String(isComparisonTrayEnabled) === 'true',
                layout: isFiveCardLayout ? '5-card' : '',
                cardTag: isPersonalWrapper && isFiveCardLayout ? 'personal' : '',
                targetExperience,
              };

              // Create a specific structure for the ResponsiveGrid
              const reqJsonData = { ...column };
              reqJsonData[':items'] = { [itemKey]: itemProps };

              componentsArray.push(
                <ResponsiveGrid model={respGridUtil(reqJsonData)} {...respGridUtil(reqJsonData)} key={itemKey} />
              );
            }
          }
        });

        if (componentsArray.length) {
          return (
            <li
              className={clsx(
                columnClass,
                isFiveCardLayout ? (!isPersonalWrapper ? 'business-wrapper pb-3' : 'personal-wrapper px-0') : ''
              )}
            >
              <div className="layout-wrapper">
                {isFiveCardLayout && !isPersonalWrapper && <div className="card-tag business-badge"> Business</div>}
                {componentsArray}
              </div>
            </li>
          );
        }
        return null;
      }
      return null;
    };
  }, [props]);

  return (
    <StyledCobrandWrapper>
      <div className={clsx('cobrand-wrapper')}>
        <Suspense fallback={''}>
          {targetMbox && !isTargetContentLoaded && !isAuthorMode ? (
            <CobrandWrapperSkeletonLoader {...props} />
          ) : (
            <VariableColumnContainerMolecule
              componentId={'vcc' + componentID}
              subHeader={subHeader}
              styleclass={styleclass}
              eyebrow={eyebrow}
              trackingProperties={trackingProperties}
              ctaLabel={ctaLabel}
              header={header}
              headerTag={headerTag}
              ctaLink={ctaLink}
              ctaType={ctaType}
              isAuthor={isAuthorMode}
              desktopColumns={desktopColumns}
              tabletColumns={tabletColumns}
              mobileColumns={mobileColumns}
              reverseStacking={reverseStacking}
              contentAlignment={contentAlignment}
              headerFontSize={headerFontSize}
              subFontSize={subFontSize}
              subHeaderTag={subHeaderTag}
              descriptionText={descriptionText}
              descFontSize={descFontSize}
            >
              {isAuthorMode &&
                Array.from({ length: wrapperArray.length }, (_, i) => (
                  <div className={wrapperArray[i][1]}>{authorComponentWrapper(i)}</div>
                ))}
              {!isAuthorMode &&
                wrapperArray.map((columnName: string[], i) => {
                  return publishComponentWrapper(columnName[0], cqItems, wrapperArray[i][1]);
                })}
            </VariableColumnContainerMolecule>
          )}
        </Suspense>
        {cobrandData.selectedCards && String(props?.isParentOfCobrandWrapper) === 'true' && (
          <CobrandComparisonTray {...props} isFromWrapper />
        )}
      </div>
    </StyledCobrandWrapper>
  );
};

export const CobrandWrapperEditableComponent = (props: any) => {
  const { model } = props;
  const cqType = model?.cqType || model?.[':type'];
  return (
    <EditableComponent config={CobrandWrapperConfig} {...props}>
      <DCADecision {...props} componentName={cqType?.split('/')?.pop()} />
    </EditableComponent>
  );
};

export const CobrandWrapper: FC<CobrandWrapperProps> = (props: CobrandWrapperProps) => {
  const { model } = props;
  const cobrandWrapperGridStyles: React.CSSProperties = {
    clear: 'both' as const,
  };
  return (
    <div
      data-testid="cobrand-wrapper"
      data-component-name="o-cobrand-cobrandwrapper"
      id={model?.componentID}
      className={clsx(
        [model?.styleclass?.includes('inverse') ? 'inverse' : ''],
        [model?.styleclass?.includes('fullbleed') ? 'm-container-fullbleed' : '']
      )}
      style={cobrandWrapperGridStyles}
    >
      <CobrandWrapperEditableComponent {...props} />
    </div>
  );
};

export const createColumn = (deskVal: number, tabVal: number, mobVal: number = 12) => {
  const item = {
    deskVal,
    tabVal,
    mobVal,
  };
  return item;
};

export const getColumnsObj = (desktopColumns = '', tabletColumns = '', mobileColumns = '') => {
  const col = [];
  if (desktopColumns !== '' || tabletColumns !== '' || mobileColumns !== '') {
    const [desktopColVals, tabletColVals] = [desktopColumns.split(','), tabletColumns.split(',')];

    switch (true) {
      case desktopColVals.length === 1 && tabletColVals.length === 1:
        {
          const deskTopCols = parseInt(desktopColumns);
          const tabCols = parseInt(tabletColumns);
          const mobCols = parseInt(mobileColumns);

          const xlVal = 12 / deskTopCols;
          const mdVal = 12 / tabCols;
          const smVal = 12 / mobCols;

          for (let i = 0; i < deskTopCols; i++) {
            const item = createColumn(xlVal, mdVal, smVal);
            col.push(item);
          }
        }
        break;
      case desktopColVals.length > 1 && tabletColVals.length > 1:
        {
          const mobCols = parseInt(mobileColumns);
          const smVal = 12 / mobCols;
          for (let i = 0; i < parseInt(desktopColVals[0]); i++) {
            const item = createColumn(parseInt(desktopColVals[i + 1]), parseInt(tabletColVals[i]), smVal);
            col.push(item);
          }
        }
        break;
      case desktopColVals.length > 1 && tabletColVals.length === 1:
        {
          const tabCols = parseInt(tabletColumns);
          const mdVal = 12 / tabCols + 1;
          const mobCols = parseInt(mobileColumns);
          const smVal = 12 / mobCols;
          for (let i = 0; i < parseInt(desktopColVals[0]); i++) {
            const item = createColumn(parseInt(desktopColVals[i + 1]), mdVal, smVal);
            col.push(item);
          }
        }
        break;
      case desktopColVals.length === 1 && tabletColVals.length > 1:
        {
          const deskTopCols = parseInt(desktopColumns);
          const xlVal = 12 / deskTopCols;
          const mobCols = parseInt(mobileColumns);
          const smVal = 12 / mobCols;
          for (let i = 0, j = 0; i < deskTopCols; i++, j++) {
            if (j === tabletColVals.length) {
              j = 0;
            }
            const item = createColumn(xlVal, parseInt(tabletColVals[j]), smVal);
            col.push(item);
          }
        }
        break;
    }
  }
  return col;
};
